###*
@ngdoc directive
@name kareo.ui.shared.directives.validation:preventFormSubmit
@element input
@description
Validation
@example
 <example module="demo">
 <file name="index.html" >
    <div class="kareo">
      <form name="igForm" novalidate>
         <div class="input-group">
          <label>Name(required)</label>
          <input type="text" name="myName" input-group-input="" ng-model="data.name" required />
          <p class="error-message">Name required</p>
        </div>
        <div class="input-group">
          <label>Async</label>
          <input type="text" name="asyncField" input-group-input="" ng-model="data.async" async-validator="" />
        </div>
        <button submit-action="submitSuccessful=true" prevent-form-submit="">Submit</button>
        {{submitSuccessful}}
      </form>
    </div>
  </file>
  <file name="demo.js">
   angular
    .module('demo', ['kareo.ui.shared.directives.validation.prevent-form-submit', 'kareo.ui.shared.directives.validation.input-group'])
    .directive('asyncValidator', function($q, $timeout) {
      return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$asyncValidators.username = function(modelValue, viewValue) {
            if (ctrl.$isEmpty(modelValue)) {
              return $q.when();
            }
            var def = $q.defer();

            $timeout(def.resolve, 2000);
            return def.promise;
          };
        }
      };
    });
   </file>
</example>
*###

angular.module 'kareo.ui.shared.directives.validation.prevent-form-submit', []

.directive "preventFormSubmit", ->
  bindToController:
    preventFormSubmit: '<?' # default: parent form element
    submitAction: '&'
  controller: ->
  controllerAs: 'kPfs'
  link: link
  restrict: "A"
  require: '^?form'

link =
  pre: (scope, element, attributes, formCtrl) ->
    ctrl = scope.kPfs
    form = ctrl.preventFormSubmit or formCtrl
    isDisabled = false

    return unless form

    form.submitPrevented = false
    element.bind "click", () ->
      scope.$apply ->
        form.submitPrevented = form.$invalid
        if form.$valid
          form.$setPristine true
          ctrl.submitAction()

    pendingChange = (pending) ->
      return if( !!pending == isDisabled)
      isDisabled = !!pending
      element.toggleClass 'disabled', isDisabled
      element.attr 'disabled', if isDisabled then 'disabled' else null

    pendingValue = -> form.$pending
    scope.$watch pendingValue, pendingChange
  

# backwards compatibility
angular.module 'kareo.ui.shared.directives.prevent-form-submit', [
  'kareo.ui.shared.directives.validation.prevent-form-submit'
]
